import { TAG } from "../constants";
import { PrescriptionMedication, PrescriptionWithProduct } from "../types";
import { patientApi } from "./patientApi";

export const prescriptionsApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getLatestPrescription: builder.query<
      PrescriptionWithProduct,
      void | { product_category?: string }
    >({
      query: (params) => ({
        method: "GET",
        url: `/api/patient/prescriptions/latest`,
        params: params?.product_category
          ? { product_category: params.product_category }
          : undefined,
      }),
      providesTags: [{ type: TAG.PRESCRIPTION, id: "LATEST" }],
    }),
    getPrescriptionDetails: builder.query<PrescriptionMedication, number>({
      query: (prescriptionId) => ({
        method: "GET",
        url: `/api/patient/prescriptions/${prescriptionId}/details`,
      }),
      providesTags: (_result, _error, prescriptionId) => [
        { type: TAG.PRESCRIPTION, id: prescriptionId },
      ],
    }),
  }),
});

export const { useGetLatestPrescriptionQuery, useGetPrescriptionDetailsQuery } =
  prescriptionsApi;
